import axios from 'axios'

export default class BaseAPIs {
  // static baseURL = 'https://cla-dev-scale.snafty.jp' //PROD Auto scale
  static baseURL = 'https://snafty-jewelry-be.test-development.work' //PROD
  // static baseURL = 'https://cla-dev.test-development.work' //DEV

  static headers = {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json'
  }
}
